import React from 'react';
import RemoteImageSplashSearchBox from '../RemoteImageSplashSearchBox';
import RemoteImageSplashList from '../RemoteImageSplashList';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';

const RemoteImageSplashListWrap = (props) => {
  const { remoteImageSplashList, setData, getList } = props;

  return (
    <div className="remote-image-list-wrap">
      {/* 원격 이미지 검색 박스 */}
      <RemoteImageSplashSearchBox
        searchData={remoteImageSplashList.searchData}
        setData={(data) =>
          setData({
            path: ['remoteImageSplashList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        getList={getList}
      />

      {/* 원격 이미지 리스트 */}
      <RemoteImageSplashList
        remoteImageList={remoteImageSplashList.list}
        initialOption={{
          pagination: _LIST_PAGINATION_MODEL,
        }}
        pagination={remoteImageSplashList.pagination}
        getList={getList}
      />
    </div>
  );
};

export default RemoteImageSplashListWrap;
